export const star_style = {
  numberOfStars: 5,
  size: 24,
  starDimension: '30px',
  starSpacing: '3px',
}
